import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { URLS } from '../../../shared/constants/api-request.urls';

@Injectable({ providedIn: 'root' })
export class DividendsService {
  private http = inject(HttpClient);

  getDividends(stockId?: string, pageNumber?: number, pageSize?: number): Observable<any> {
    let params = new HttpParams()
      .set('pageNumber', pageNumber || 1)
      .set('pageSize', pageSize || 20);
    if (stockId) {
      params = params.set('stockId', stockId);
    }
    return this.http.get(URLS.DIVIDEND, { params });
  }

  getDividendById(id: string): Observable<any> {
    return this.http.get(`${URLS.DIVIDEND}/${id}?mode=edit`);
  }

  createDividend(dividend: any): Observable<any> {
    console.log('Creating dividend:', dividend);
    return this.http.post(URLS.DIVIDEND, dividend);
  }

  updateDividend(id: string, dividend: any): Observable<any> {
    return this.http.put(`${URLS.DIVIDEND}/${id}`, dividend);
  }

  deleteDividend(id: string): Observable<any> {
    return this.http.delete(`${URLS.DIVIDEND}/${id}`);
  }
}
